export default __webpack_public_path__ + "2a01c3f73daca756582b20dad764deb7.png";